import React from 'react';
import MusicTab from '../tabs/MusicTab';
import MusicList from '../music list/MusicList';
import './Home.css';

function Home() {
  return (
    <div>
      <MusicTab />
      <MusicList />
    </div>
  );
}

export default Home;
